module.exports = __webpack_public_path__ + "img/study03.8d30bf1d.png";